module.exports = __webpack_public_path__ + "static/media/investHeader.cd6a20fb.png";